import React, { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports -- v5 form stack, migrate to v7 (DX-194)
import { Controller, useFormContext } from 'react-hook-form-legacy';
import { SelectMultipleEmployeeOrTeamAsyncConnected } from '../../../apps/dashboard/components/Selects/SelectMultipleEmployeeOrTeamAsyncConnected';
import { EmployeeOrTeamOption } from '../../../apps/dashboard/components/Selects/EmployeeOrTeamOptionLabel';
import InputError from '../InputError';
import { getError } from '../utils';

export type Props = {
  name: string;
};

export const SelectMultipleEmployeeOrTeamConnectedControlled: React.FC<
  React.PropsWithChildren<Props>
> = ({ name }) => {
  const { control, errors } = useFormContext();

  const error = getError(name, errors);

  const renderAs = useCallback(
    ({
      value,
      onChange,
    }: {
      value: EmployeeOrTeamOption[];
      onChange: (values: EmployeeOrTeamOption[]) => void;
    }) => {
      return (
        <SelectMultipleEmployeeOrTeamAsyncConnected
          values={value}
          onChange={onChange}
          className={error ? 'is-invalid' : ''}
          error={!!error}
        />
      );
    },
    [error],
  );

  return (
    <>
      {/* `value` is required by the inferred `as` component's props, but react-hook-form's
          Controller always overrides it internally with the live form value at runtime. */}
      <Controller as={renderAs} value={[]} name={name} control={control} />
      <InputError error={error} />
    </>
  );
};
